import { Component, ElementRef, HostListener, OnInit, Renderer2, ViewChild } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { DECIMAL_RADIX } from 'src/app/common/Definitions/shared.definitions';
import { ServerApi } from 'src/app/services/api.services/server.api';
import { SessionApiSvc } from 'src/app/services/api.services/session.api.svc';
import { PermissionsManager } from 'src/app/services/permissions-manager';
import { SvgIconsService } from 'src/app/services/svg-icons.service';
import { IUserData, UserDetailsService } from 'src/app/services/user-details.service';
import { TourDataService } from 'src/app/services/tour-data.service';
import { SetLimitedAccessConf, ClosePanel, SetAppConf, SetPointCloudSession } from 'src/app/Store/app.state/app.actions';
import { APPLICATION_MODE, IAppConf, SCENE_MODE } from 'src/app/Store/app.state/app.model';
import { AppState } from 'src/app/Store/app.state/app.state';
import { ISite } from 'src/app/Store/sites.state/sites.model';
import { RolesState } from 'src/app/Store/role.state/roles.state';

import { HeaderComponent } from '../header.container/header/header.component';
import { BlockHostFrameDirective } from '../../Directives/blockHostFrame.directive';
import { SideBarContainer } from '../content.container/side-bar.container/side-bar.container';
import { ResizableDirective } from '../../Directives/resizable/resizable.directive';
import { ClickOutsideDirective } from '../../Directives/clickOutside.directive';
import { SearchResMenuComponent } from '../content.container/side-bar.container/subMenus/search-res-menu/search-res-menu.component';
import { SitesMenuComponent } from '../content.container/side-bar.container/subMenus/sites-menu/sites-menu.component';
import { ZonesMenuComponent } from '../content.container/side-bar.container/subMenus/zones-menu/zones-menu.component';
import { LayersMenuComponent } from '../content.container/side-bar.container/subMenus/layers-menu/layers-menu.component';
import { ViewpointsMenuComponent } from '../content.container/side-bar.container/subMenus/viewpoints-menu/viewpoints-menu.component';
import { DiscussionMenuComponent } from '../content.container/side-bar.container/subMenus/discussion-menu/discussion-menu.component';
import { AdminPanelComponent } from '../content.container/side-bar.container/subMenus/admin-panel/admin-panel.component';
import { HelpPanelComponent } from '../content.container/side-bar.container/subMenus/help-panel/help-panel.component';
import { SettingsPanelComponent } from '../content.container/side-bar.container/subMenus/settings-panel/settings-panel.component';
import { ProfilePanelComponent } from '../content.container/side-bar.container/subMenus/profile-panel/profile-panel.component';
import { LoadingLineComponent } from '../../common/UI-Components/loading-line/loading-line.component';
import { StatusContainer } from '../footer.container/status-continaer/status.container';
import { TourPlacemarkMenuComponent } from "../content.container/side-bar.container/subMenus/tour-placemark-menu/tour-placemark-menu.component";
import { DataPrivacyType } from 'src/app/common/Models/UI/company-info.interface';
import { SiemensAnalyticsService } from 'src/app/services/siemens-analytics.service';
import { DataPrivacyApiSvc } from 'src/app/services/api.services/data-privacy.api.svc';
import { ApiTools } from 'src/app/services/api.services/api.tools';
import { SseApiSvc } from 'src/app/services/api.services/SSE/sse.api.svc';
import { TooltipDirective } from 'src/app/Directives/tooltip.directive';

enum SIDEBAR_OPTIONS {
  SIDEBAR_SITES = 'sidebar.sites',
  SIDEBAR_SEARCH = 'sidebar.search'
}

@Component({
    selector: 'ins-application-layout',
    templateUrl: './application-layout.component.html',
    styleUrls: ['./application-layout.component.scss'],
    imports: [
    HeaderComponent,
    BlockHostFrameDirective,
    SideBarContainer,
    ResizableDirective,
    ClickOutsideDirective,
    SearchResMenuComponent,
    SitesMenuComponent,
    ZonesMenuComponent,
    LayersMenuComponent,
    ViewpointsMenuComponent,
    DiscussionMenuComponent,
    AdminPanelComponent,
    HelpPanelComponent,
    SettingsPanelComponent,
    ProfilePanelComponent,
    LoadingLineComponent,
    RouterOutlet,
    StatusContainer,
    TourPlacemarkMenuComponent,
    TooltipDirective
],
})
export class ApplicationLayoutComponent implements OnInit {
  readonly APPLICATION_MODE = APPLICATION_MODE;

  @HostListener('document:contextmenu', ['$event'])
  public rightClick(event: MouseEvent): void {
    if (event.target['type'] !== 'text' && event.target['type'] !== 'textarea') {
      event.preventDefault();
    }
  }

  appConf$: Observable<IAppConf>;
  public appConf: IAppConf;

  private _subMenuWidth: number = 270;
  private _subMenuSearchWidth: number = 540;
  public sidebarMenuWidth: number = 270;
  @ViewChild('sideBarSubMenu', {static: true}) _sideBarSubMenu: ElementRef;

  readonly selectedMode$: Observable<SCENE_MODE>;
  public sceneMode: SCENE_MODE;

  readonly pressedPanelName$: Observable<string>;
  public openedPanel: string = '';
  
  readonly activeSite$: Observable<ISite>;
    activeSiteName: string = 'No Site Selected';

  public currentPage: string = '';
  public currentUser: IUserData = null;
  public headerTitle: string = '';
  public tourTitle: string = '';
  constructor(private readonly svgIconService: SvgIconsService, private readonly serverApi: ServerApi, private readonly store: Store, private readonly sessionApiSvc: SessionApiSvc,
    private readonly renderer: Renderer2, private readonly userDetailsService: UserDetailsService, private readonly router: Router, private readonly tourDataService: TourDataService,
    private readonly siemensAnalyticsService: SiemensAnalyticsService, private readonly dataPrivacyApiSvc: DataPrivacyApiSvc, private readonly sseApiSvc: SseApiSvc
  ) {
    this.appConf$ = this.store.select(AppState.getAppConf);
    this.selectedMode$ = this.store.select(AppState.getSelectedMode);
    this.pressedPanelName$ = this.store.select(AppState.getOpenedPanel);
    this.activeSite$ = this.store.select(AppState.getActiveSite);
    PermissionsManager.init(serverApi);
    console.log('APP COM CTOR');
    this.svgIconService.init();

    const sessionId: string = localStorage.getItem('intosite_session');
    sessionStorage.setItem('tabId', `${Date.now()}-${crypto.getRandomValues(new Uint32Array(1))[0]}`);
    this.sessionApiSvc.sessionId = sessionId;
    this.store.dispatch(new SetPointCloudSession(JSON.parse(localStorage.getItem('pointCloudSession'))));

    if (!ApiTools.isThroughLoginPage) {
      localStorage.setItem('intosite_session_counter', (+localStorage.getItem('intosite_session_counter') + 1).toString());
      ApiTools.sessionIndex = +localStorage.getItem('intosite_session_counter');
    }
    this.handleSiemensAnalyticsOnStartup();

    this.store.dispatch(new SetLimitedAccessConf({
      disable3DModels: false,
      disableImportScans: false,
      limitSites: false,
      limitSiteCount: 3,
      disableTemplateManagement: false
    }));

    window.addEventListener('storage', this.storageChange.bind(this));

    this.appConf$.subscribe( (appConf: IAppConf) => {
      this.appConf = appConf;
    });

    this.userDetailsService.getUserDetailsAsync().subscribe((user: IUserData) => {
      this.currentUser = user;
    });

    // Subscribe to tour title changes
    this.tourDataService.tourTitle$.subscribe((title: string) => {
      this.tourTitle = title;
      this.setHeaderTitle();
    });

    this.selectedMode$.subscribe((mode: SCENE_MODE) => {
      this.sceneMode = mode;
    });
    this.pressedPanelName$.subscribe((name: string) => {
      this.handleSideBarSubMenu(name);
    });

    this.activeSite$.subscribe((site: ISite) => {
      if (site) {
        this.activeSiteName = site.name;
      } else {
        this.activeSiteName = 'No Site Selected';
      }
      this.setHeaderTitle();
    });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const url = event.urlAfterRedirects.split('?')[0];
        const segments = url.split('/').filter(Boolean);
        this.currentPage = segments.length > 0 ? `/${segments[0]}` : '/';

        // Clear tour data when leaving tour route
        if (this.currentPage !== '/Tour') {
          this.tourDataService.clearAllTourData();
        }

        if (this.currentPage === '/usermanagement' || this.currentPage === '/rolemanagement' || this.currentPage === '/Tour') {
          const defaultAppConf: IAppConf = {
            appMode: APPLICATION_MODE.STANDALONE,
            readonly: false,
            sideBarContainer: true,
            webGLToolbar: true,
            panoToolbar: true,
            loadSpecificSite: false,
            showMap: true
          }
          this.store.dispatch(new SetAppConf(defaultAppConf));
        }

        this.setHeaderTitle();
      }
    })
  }

  ngOnInit(): void {
    if (!this.currentPage.includes('publicTour')) {
      this.loadCurrentUser();
    }
    if (this.currentPage !== '/usermanagement') {
      this.initSse();
    }
  }

  async initSse(): Promise<void> {
    await this.sseApiSvc.regSse();
  }

  storageChange(event$: any): void {
    if (event$.key == null || (event$.key === 'intosite_session' && localStorage.getItem('intosite_session') === null)) {
      this.sessionApiSvc.expiredSessionMessage();
    }
  }

  private async loadCurrentUser(): Promise<void> {
    await this.sessionApiSvc.getCurrentUser();
  }

  private setHeaderTitle(): void {
    if (this.currentPage === '/') {
      this.headerTitle = this.activeSiteName;
    } else if (this.currentPage === '/usermanagement') {
      this.headerTitle = 'User Management';
    } else if (this.currentPage === '/rolemanagement') {
      const isPermissionsPage = this.router.url.split('?')[0].startsWith('/rolemanagement/manage-permissions');
      const selectedRole = isPermissionsPage ? this.store.selectSnapshot(RolesState.getSelectedRole) : null;
      this.headerTitle = isPermissionsPage ? (selectedRole?.name || 'Role Management') : 'Role Management';
    } else if (this.currentPage.startsWith('/Tour')) {
      this.headerTitle = this.tourTitle;
    } else {
      this.headerTitle = 'Intosite';
    }
  }

  public getTooltip(textElement: any, text: string): string {
    if (textElement?.offsetWidth < textElement.scrollWidth) {
      return text;
    }
    return '';
  }

  handleSideBarSubMenu(openedPanel): void {
    if (this._sideBarSubMenu?.nativeElement && this.appConf.sideBarContainer) {
      if (openedPanel === '') {
        this.renderer.setStyle(this._sideBarSubMenu.nativeElement, 'transform', `scaleX(0)`);
        this.renderer.setStyle(this._sideBarSubMenu.nativeElement, 'width', `0px`);
      } else {
        if (openedPanel === SIDEBAR_OPTIONS.SIDEBAR_SEARCH) {
          this.sidebarMenuWidth = this._subMenuSearchWidth;
        } else {
          this.sidebarMenuWidth = this._subMenuWidth;
        }
        this.renderer.setStyle(this._sideBarSubMenu.nativeElement, 'width', `${this.sidebarMenuWidth}px`);
        this.renderer.setStyle(this._sideBarSubMenu.nativeElement, 'transform', `scaleX(1)`);
      }
      this.openedPanel = openedPanel;
    }
  }

  handleClickOutside(): void {
    const effectedPanelsWhenClickedOutside: string[] = ['panels.admin', 'panels.help', 'panels.settings', 'panels.profile'];
    if (effectedPanelsWhenClickedOutside.indexOf(this.openedPanel) !== -1) {
      this.closePanel();
    }
  }
  
  closePanel(): void {
    this.store.dispatch(new ClosePanel());
  }

  updateWidth(newWidth: string): void {
    if (this.openedPanel === SIDEBAR_OPTIONS.SIDEBAR_SEARCH) {
      this._subMenuSearchWidth = parseInt(newWidth, DECIMAL_RADIX);
    } else {
      this._subMenuWidth = parseInt(newWidth, DECIMAL_RADIX);
    }
  }

  public handleSiemensAnalyticsOnStartup() {
    // Siemens Analytics init
    this.siemensAnalyticsService.initSession();
    if (+localStorage.getItem('intosite_session_counter') === 1) {
      // Siemens Analytics data privacy consent
      this.dataPrivacyApiSvc.openDataPrivacyDialog(DataPrivacyType.PEP, true);
      // Log Siemens Analytics event
      this.siemensAnalyticsService.logEvent('INS_Login', false);
    }
  }

}
